import {TableColumn} from "../../../Component/Model/Table/Table";
import {DefaultCell} from "../../../Component/Common/Components/DataTable/DefaultCell";
import {StagedData} from "../../../Component/Model/Dto/Staging/StagedData";
import {TableDateHelper} from "../../../Component/Model/helpers";
import {ValidationFailuresCell} from "./ValidationFailuresCell";

interface StagedTable<TRow> {
    columns: Array<TableColumn>;
    rows: Array<TRow>;
}

const yesNo = (value?: boolean) => value === undefined || value === null ? "" : value ? "Yes" : "No";

const date = (value?: Date) => value ? TableDateHelper(value.toString()) ?? "" : "";

const failuresColumn: TableColumn = {
    Header: 'Validation',
    accessor: 'validation',
    Cell: ValidationFailuresCell,
    disableSortBy: true
};

const individualColumns: TableColumn[] = [
    {Header: 'Employee Code', accessor: 'employeeCode', Cell: ({value}: any) => <DefaultCell value={value}/>, disableSortBy: true},
    {Header: 'First Name', accessor: 'firstname', Cell: ({value}: any) => <DefaultCell value={value}/>, disableSortBy: true},
    {Header: 'Surname', accessor: 'surname', Cell: ({value}: any) => <DefaultCell value={value}/>, disableSortBy: true},
    {Header: 'ID Number', accessor: 'idNumber', Cell: ({value}: any) => <DefaultCell value={value}/>, disableSortBy: true},
    {Header: 'Date of Birth', accessor: 'dateOfBirth', Cell: ({value}: any) => <DefaultCell value={value}/>, disableSortBy: true},
    {Header: 'Race', accessor: 'race', Cell: ({value}: any) => <DefaultCell value={value}/>, disableSortBy: true},
    {Header: 'Gender', accessor: 'gender', Cell: ({value}: any) => <DefaultCell value={value}/>, disableSortBy: true},
    {Header: 'Nationality', accessor: 'nationality', Cell: ({value}: any) => <DefaultCell value={value}/>, disableSortBy: true},
    {Header: 'Disabled', accessor: 'disabled', Cell: ({value}: any) => <DefaultCell value={value}/>, disableSortBy: true},
    {Header: 'Province', accessor: 'province', Cell: ({value}: any) => <DefaultCell value={value}/>, disableSortBy: true},
    failuresColumn
];

export function StagedIndividualTableMapper(dataRows: StagedData.Individual[]): StagedTable<object> {
    const rows = (dataRows ?? []).map(item => ({
        employeeCode: item.employeeCode,
        firstname: item.firstname,
        surname: item.surname,
        idNumber: item.idNumber,
        dateOfBirth: date(item.dateOfBirth),
        race: item.race,
        gender: item.gender,
        nationality: item.nationality,
        disabled: yesNo(item.disabled),
        province: item.province,
        validation: item.validationFailures
    }));

    return {columns: individualColumns, rows};
}

const individualEmployeeDataColumns: TableColumn[] = [
    {Header: 'Employee Code', accessor: 'employeeCode', Cell: ({value}: any) => <DefaultCell value={value}/>, disableSortBy: true},
    {Header: 'First Name', accessor: 'firstname', Cell: ({value}: any) => <DefaultCell value={value}/>, disableSortBy: true},
    {Header: 'Surname', accessor: 'surname', Cell: ({value}: any) => <DefaultCell value={value}/>, disableSortBy: true},
    {Header: 'ID Number', accessor: 'idNumber', Cell: ({value}: any) => <DefaultCell value={value}/>, disableSortBy: true},
    {Header: 'Occupational Level', accessor: 'occupationalLevel', Cell: ({value}: any) => <DefaultCell value={value}/>, disableSortBy: true},
    {Header: 'Position', accessor: 'position', Cell: ({value}: any) => <DefaultCell value={value} tooltip={true} maxWidth={'250px'}/>, disableSortBy: true},
    {Header: 'Permanent', accessor: 'permanent', Cell: ({value}: any) => <DefaultCell value={value}/>, disableSortBy: true},
    {Header: 'Start Date', accessor: 'startDate', Cell: ({value}: any) => <DefaultCell value={value}/>, disableSortBy: true},
    {Header: 'End Date', accessor: 'endDate', Cell: ({value}: any) => <DefaultCell value={value}/>, disableSortBy: true},
    {Header: 'Training Received', accessor: 'trainingReceived', Cell: ({value}: any) => <DefaultCell value={value}/>, disableSortBy: true},
    failuresColumn
];

export function StagedIndividualEmployeeDataTableMapper(dataRows: StagedData.IndividualEmployeeData[]): StagedTable<object> {
    const rows = (dataRows ?? []).map(item => ({
        employeeCode: item.employeeCode,
        firstname: item.firstname,
        surname: item.surname,
        idNumber: item.idNumber,
        occupationalLevel: item.occupationalLevel,
        position: item.position,
        permanent: yesNo(item.permanent),
        startDate: date(item.startDate),
        endDate: date(item.endDate),
        trainingReceived: yesNo(item.trainingReceived),
        validation: item.validationFailures
    }));

    return {columns: individualEmployeeDataColumns, rows};
}

const individualSalaryColumns: TableColumn[] = [
    {Header: 'Employee Code', accessor: 'employeeCode', Cell: ({value}: any) => <DefaultCell value={value}/>, disableSortBy: true},
    {Header: 'First Name', accessor: 'firstname', Cell: ({value}: any) => <DefaultCell value={value}/>, disableSortBy: true},
    {Header: 'Surname', accessor: 'surname', Cell: ({value}: any) => <DefaultCell value={value}/>, disableSortBy: true},
    {Header: 'ID Number', accessor: 'idNumber', Cell: ({value}: any) => <DefaultCell value={value}/>, disableSortBy: true},
    {Header: 'Type', accessor: 'salaryType', Cell: ({value}: any) => <DefaultCell value={value}/>, disableSortBy: true},
    {Header: 'Month', accessor: 'yearMonth', Cell: ({value}: any) => <DefaultCell value={value}/>, disableSortBy: true},
    {Header: 'Amount', accessor: 'amount', Cell: ({value}: any) => <DefaultCell value={value}/>, disableSortBy: true},
    failuresColumn
];

export function StagedIndividualSalaryTableMapper(dataRows: StagedData.IndividualSalary[]): StagedTable<object> {
    const rows = (dataRows ?? []).map(item => ({
        employeeCode: item.employeeCode,
        firstname: item.firstname,
        surname: item.surname,
        idNumber: item.idNumber,
        salaryType: item.salaryType,
        yearMonth: item.yearMonth,
        amount: item.amount?.toLocaleString('en-ZA', {minimumFractionDigits: 2, maximumFractionDigits: 2}) ?? "",
        validation: item.validationFailures
    }));

    return {columns: individualSalaryColumns, rows};
}
